import { Forecast, ForecastListItem } from '@futrli-sdk/predict';

import {
  ExcelForecastCreatePayload,
  ForecastWindowPayload,
  ForecastWindowSpec,
  PREVIOUS_ACTUALS_FINANCIAL_YEARS
} from '@futrli/shared-services/excel-upload/types';

export enum ForecastType {
  BUDGET = 'budget',
  SCENARIO = 'scenario',
  SCENARIO_WITH_INVOICES = 'scenario-with-invoices'
}

export enum NewForecastDataSource {
  FromScratch = 'from_scratch',
  FromLYA = 'from_lya',
  WithAutoPredictions = 'auto_predictions',
  FromDuplicate = 'from_duplicate',
  FromExcelUpload = 'from_excel_upload'
}

export enum NewConsolidatedForecastDataSource {
  CREATE_FROM_SCRATCH = 'create-from-scratch',
  CREATE_FROM_AI_ASSUMPTIONS = 'create-from-ai-assumptions',
  CREATE_FROM_ACTUALS = 'create-from-actuals',
  CREATE_FROM_EXISTING = 'create-from-existing',
  CREATE_FROM_EXISTING_SUB_ENTITY_FORECASTS = 'create-from-existing-sub-entity-forecasts'
}

export enum ForecastKind {
  BUDGET_FROM_SCRATCH = 'budget-from-scratch',
  BUDGET_FROM_ACTUALS = 'budget-from-actuals',
  BUDGET_FROM_EXISTING = 'budget-from-existing',
  SCENARIO_FROM_SCRATCH = 'scenario-from-scratch',
  SCENARIO_FROM_ACTUALS = 'scenario-from-actuals',
  SCENARIO_FROM_EXISTING = 'scenario-from-existing'
}

export type ForecastUpdatePayload =
  | Partial<Forecast>
  | (Partial<Omit<Forecast, 'window_from' | 'window_spec'>> & ForecastWindowPayload);

export interface CreateNewForecastPayload extends ForecastWindowPayload {
  kind: string;
  name: string;
  categories_with_ai_enabled?: string[] | null;
  from_forecast_id?: string;
  forecast_from_date?: string;
  include_unpaid_invoices?: boolean;
}

type SharedForecastProps = Required<
  Pick<ForecastListItem, 'id' | 'created' | 'modified' | 'owner_id' | 'status' | 'kind' | 'name' | 'forecast_from_date'>
>;
type UnsharedForecastProps = Partial<
  Pick<ForecastListItem, 'is_frozen' | 'is_hidden' | 'include_ai_assumptions' | 'include_unpaid_invoices' | 'checklist'>
>;
export interface OrgOrConForecastListItem extends SharedForecastProps, UnsharedForecastProps {}

export { ExcelForecastCreatePayload, ForecastWindowPayload, ForecastWindowSpec, PREVIOUS_ACTUALS_FINANCIAL_YEARS };
